import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import useAppBarScrollTrigger from 'hooks/useAppBarScrollTrigger';

import Container from 'components/Container';
import { Topbar, Sidebar, Footer } from './components';

import AlertPopup from 'components/AlertPopup';
import { useDispatch, useSelector } from 'react-redux';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import { updateUiState } from '@/redux/slices/uiSlice';
import { hideAlert } from 'redux/slices/alertSlice';

const PublicFluid = ({
  children,
  bgcolor = 'transparent',
  noTopbar,
  noFooter,
  leftSidebar,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [openSidebar, setOpenSidebar] = useState(false);
  const alertState = useSelector((state) => state.alertState);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const open = isMd ? false : openSidebar;

  const trigger = useAppBarScrollTrigger();

  useEffect(() => {
    dispatch(
      updateUiState({
        key: 'dashboardSidebarExpanded',
        value: isMd,
      }),
    );
  }, [isMd, dispatch]);

  return (
    <ErrorBoundary>
      <Box>
        {!noTopbar ? (
          <AppBar
            position={'sticky'}
            sx={{
              top: 0,
              backgroundColor: trigger
                ? theme.palette.background.paper
                : bgcolor,
            }}
            elevation={trigger ? 1 : 0}
          >
            <Container paddingY={1} maxWidth={{ sm: 1, md: 1236 }}>
              <Topbar onSidebarOpen={handleSidebarOpen} />
            </Container>
          </AppBar>
        ) : null}
        <Sidebar onClose={handleSidebarClose} open={open} variant="temporary" />
        {leftSidebar ? (
          <Sidebar onClose={() => {}} open={true} variant="permanent" />
        ) : null}
        <main>
          <AlertPopup
            open={alertState.open}
            autoHideDuration={6000}
            handleClose={() => dispatch(hideAlert())}
            message={alertState.message}
            type={alertState.type}
            verticalLocation={alertState.vertical}
            horizontalLocation={alertState.horizontal}
          ></AlertPopup>
          {children}
          {!noFooter ? <Divider /> : null}
        </main>
        {!noFooter ? (
          <Container paddingY={1} maxWidth={{ sm: 1, md: 1236 }}>
            <Footer />
          </Container>
        ) : null}
      </Box>
    </ErrorBoundary>
  );
};

PublicFluid.propTypes = {
  children: PropTypes.node,
  bgcolor: PropTypes.string,
  noTopbar: PropTypes.bool,
  noFooter: PropTypes.bool,
  leftSidebar: PropTypes.bool,
};

export default PublicFluid;
